// extracted by mini-css-extract-plugin
module.exports = {"container":"_3Q7K5QHa","isSmallSpacing":"_3nwMDzKR","is2Column":"mcgSfOuw","is3Column":"_3Mk9Wzu9","is4Column":"RAB6vgnE","is5Column":"_2Z4hXMQC","isCenter":"aMX1qSLW"};